import { render } from "./DetailsPage.vue?vue&type=template&id=2a2f96e4&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"

import "./DetailsPage.vue?vue&type=style&index=0&id=2a2f96e4&scoped=true&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2f96e4"]])

export default __exports__